<template>
  <div>
    <!-- ---------- -->

    <div class="footer_warp">
      <div class="footer_cont">
        <!-- 上部 -->
        <div class="footer_cont_l">
          <!--上部 左 -->
          <div class="footer_cont_l_div">
            <div class="footer_cont_l_div_item">
              <div class="footer_cont_l_title">企业概况</div>
              <div class="footer_cont_l_ul">
                <p
                  v-for="(item, index) in arrList"
                  :key="index"
                  @click="toGuid(item.url, item.id)"
                >
                  {{ item.title }}
                </p>
              </div>
            </div>
            <div class="footer_cont_l_div_item">
              <div class="footer_cont_l_title">企业新闻</div>
              <div class="footer_cont_l_ul">
                <p
                  v-for="(item, index) in arrList3"
                  :key="index"
                  @click="toNews(item.url)"
                >
                  {{ item.title }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- top 中 -->
        <div class="footer_cont_c">
          <div>
            <img :src="siteInfo.logo" alt="" />
          </div>
          <div>
            <p class="address">
              公司总部地址：{{siteInfo.address}}<br />
              邮箱：{{siteInfo.email}}
            </p>
          </div>
        </div>
        <!-- top 右 -->
        <div class="footer_cont_r">
          <div style="display: flex;flex-flow: row">
             <div class="footer_cont_r_border">
               <img :src="siteInfo.qrcode[0]" alt=""/>
               <p>关注微信小程序</p>
            </div>
            <div class="footer_cont_r_border">
              <img :src="siteInfo.qrcode[1]" alt="" />
              <p>关注微信公众号</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 下部 -->
      <div class="footer_warp_btm">
        <p>Copyright©城际物流（南京）有限公司&ensp;&ensp;&ensp;{{siteInfo.icp}}</p>
      </div>
    </div>

    <!-- --------- -->
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      arrList: [
        {
          title: "关于企业",
          url: "/company",
          id: "company",
        },
      ],
      arrList2: [],
      arrList3: [
        {
          title: "最新新闻",
          url: "/news",
        },
      ],
      siteInfo:{}
    };
  },
  created() {
    let that = this;
    that.siteInfo = this.commFunc.getSession('setSiteInfoByStore')
    // console.log(that.siteInfo)
  },
  methods: {
    // 锚点跳转
    toGuid(path) {
      this.$router.push(path);
    },
    toPages(url) {
      this.$router.push(url);
    },
    toNews(url) {
      this.$router.push(url);
    },
  },
};
</script>
<style scoped>
@charset "utf-8";
.footer_warp {
  width: 100%;
  background: #17213d;
}
.footer_cont {
  width: 100%;
  display: flex;
  justify-content: center;
}
.footer_cont_l {
  font-size: 16px;
  font-weight: 500;
  color: #dddddd;
  line-height: 22px;
  padding-top: 77px;
}
.footer_cont_l_title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #dddddd;
  line-height: 22px;
  width: 64px;
}
.footer_cont_l_ul {
  margin-top: 36px;
}
.footer_cont_l_ul p {
  font-size: 14px;
  list-style-type: none;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  margin-top: 10px;
  cursor: pointer;
}
.footer_cont_l_div {
  display: flex;
}
.footer_cont_l_div_item {
  margin-right: 72px;
}
.footer_cont_c {
  margin-top: 70px;
  margin-left: 80px;
}
.address {
  width: 467px;
  font-size: 16px;
  font-family: "PingFangSC-Regular", "PingFang SC";
  font-weight: 400;
  color: #ffffff;
  line-height: 32px;
  margin-top: 42px;
}
.footer_cont_r {
  margin-top: 79px;
  margin-left: 70px;
}
.footer_cont_r p {
  text-align: center;
  font-size: 14px;
  font-family: "PingFangSC-Regular";
  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
  margin-top: 17px;
}
.footer_cont_r_border {
  display: flex;
  flex-flow: column;
  margin: 7px 8px;
}
.footer_cont_r_border img {
  width: 95px;
  height: 95px;
}
.footer_warp_btm {
  width: 100%;
  border-top: 1px solid #444444;
}
.footer_warp_btm p {
  font-size: 12px;
  font-weight: 400;
  color: #a3a3a3;
  line-height: 48px;
  padding-left: 20px;
}
</style>
